export const NEWLY_BUILT_CATEGORY_TYPE = 'NEWLYBUILTPROJECT';
